<template>
    <div class="wz-article-list-con wz_list wz_wrapper" v-if="checkList()">
        <div
            v-for="category in categoryList"
            :key="category.webzine_category_code"
            style="padding:10px;"
        >
            <el-row
                v-for="(articleListByCode, idx) in getArticleList(category)"
                :key="idx"
            >
                <el-col
                    v-for="(article, idx) in articleListByCode"
                    :key="article.article_id"
                    :md="
                        getColSize(
                            articleListByCode.length,
                            category.column_count,
                            idx
                        )
                    "
                    :sm="24"
                    :class="category.webzine_category_code.toLowerCase()"
                >
                    <div
                        class="wz-article-con"
                        @click="moveArticle(article.article_id)"
                    >
                        <div
                            class="article-img"
                            v-if="article.mainImgFile"
                            :style="{
                                backgroundImage:
                                    'url(' +
                                    getMainImage(article.mainImgFile) +
                                    ')',
                            }"
                        ></div>
                        <div class="desc">
                            <!-- <p>{{ category.webzine_category_name }}</p> -->
                            <span class="desc-span">{{
                                article.article_title
                            }}</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "WebZineViewArticleList",
    computed: {
        ...mapGetters("webzineView", [
            "articleMapByCode",
            "categoryList",
            "selectedWebZineId",
            "mode",
            "webzine",
        ]),
    },
    data() {
        return {
            activeArticleId: undefined,
        };
    },
    methods: {
        getArticleList(category) {
            return this.articleMapByCode[category.webzine_category_code];
        },
        getMainImage(mainImgFile) {
            if (mainImgFile) {
                return [
                    this.$baseURL,
                    "image" + mainImgFile.server_path,
                    mainImgFile.new_name,
                ].join("/");
            } else {
                return "";
            }
        },
        getColSize(numOfArticle, numOfCol, index) {
            const mod = numOfArticle % numOfCol;
            return numOfArticle - mod > index ? 24 / numOfCol : 24 / mod;
        },

        moveArticle(article_id) {
            this.$router.push(
                `/${this.mode}/${this.selectedWebZineId}/articles/${article_id}`
            );
        },

        checkList() {
            const now = new Date();
            const publishDate = new Date(this.webzine.publish_date);
            if (this.mode === "publish" && now <= publishDate) {
                return false;
            } else {
                return true;
            }
        },
    },
};
</script>

<style scoped>
.desc-span {
    font-weight: 700;
}
.wz_list .cover .desc .desc-span {
    color: white !important;
}
.wz_list .desc .desc-span {
    color: rgba(56, 58, 74, 0.9) !important;
}

.wz-article-list-con {
    color: #333;
}

.wz-article-con {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    position: relative;
    cursor: pointer;
}

.general .wz-article-con {
    cursor: default;
}

.general .wz-article-con .wz-article__title {
    font-size: 15px;
    cursor: pointer;
}

.general .wz-article-con .wz-article__title:hover {
    color: #409eff;
}

.article-img {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
}

.wz-article-cover {
    background-color: #333;
    opacity: 0.7;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.wz-article-cover__box {
    display: flex;
}

.wz-article-cover__title {
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    flex-direction: column;
}

.wz-article-cover__title-category {
    font-size: 14px;
    color: #f7f7f7;
}

.cover {
    height: 450px;
    position: relative;
    padding: 10px 10px 0px 10px;
}

.expert {
    height: 320px;
    position: relative;
    padding: 10px;
}

.general {
    height: 320px;
    position: relative;
    padding: 10px;
}
</style>
